<div
  [style]="rectangleStyle"
  [style.top]="reportRectangle.top"
  [style.left]="reportRectangle.left"
  [style.width]="reportRectangle.width"
  [style.height]="reportRectangle.height"
  [style.z-index]="reportRectangle.zIndex"
  [style.border-width]="reportRectangle.borderWidth"
  [style.border-color]="reportRectangle.borderColor"
  [style.border-style]="reportRectangle.borderStyle"
  [style.background-color]="reportRectangle.backgroundColor"
></div>
